var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topic",on:{"click":_vm.handleTopicSelect}},[_c('h6',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.index + 1)+". ")]),_c('div',{ref:"topic"})])
}
var staticRenderFns = []

export { render, staticRenderFns }